import { DataEntry, JournalEntry } from 'general-ledger/types';
import { JournalEntry1099 } from './transactions-1099-container/types';

const compile1099ViewData = (journalEntries: Array<JournalEntry1099>) => {
  const journalEntriesMap: Map<string, JournalEntry> = new Map();
  const dataEntriesMap: Map<string, DataEntry> = new Map();
  journalEntries.map(originalJournalEntry => {
    const journalEntry = {
      id: originalJournalEntry.id,
      clientComments: originalJournalEntry.clientComments,
      dataEntries: [] as DataEntry[],
      dateOfTransaction: originalJournalEntry.documentDate,
      internalNotes: originalJournalEntry.internalNotes,
      transferId: originalJournalEntry.id,
      vendorName: originalJournalEntry.vendor,
      relatedJE: { id: '' },
      contractorId:
        originalJournalEntry.contractorId === null
          ? ''
          : originalJournalEntry.contractorId.toString(),
      source1099: originalJournalEntry.source1099,
      isTagged1099: true,
      contractorName: originalJournalEntry.contractorName,
    };
    originalJournalEntry.dataEntries.forEach(originalDataEntry => {
      const dataEntry: DataEntry = {
        id: originalDataEntry.id,
        amountInCents: originalDataEntry.amount,
        hasPotentialQualityIssues: false,
        journalEntry,
      };
      journalEntry.dataEntries.push(dataEntry);
      dataEntriesMap.set(dataEntry.id, dataEntry);
    });
    journalEntriesMap.set(originalJournalEntry.id, journalEntry);
  });
  return {
    dataEntriesMap,
    journalEntriesMap,
  };
};

export default compile1099ViewData;
